/**
 * JET Atolye Photo Library - Faz D
 * =================================
 * 32-foto kutuphane state (in-memory + drag-drop binding).
 *
 * Library tile -> canvas drag/click ile foto eklenir. localStorage'a yazilmaz
 * (32 x 5MB = 160MB risk). Reload sonrasi kütüphane temizlenir, layout iskeleti
 * korunur (canvas autoSave fabric JSON'a yazar).
 *
 * Public API:
 *   JetPhotoLibrary.add(file) -> Promise<photoId>
 *   JetPhotoLibrary.remove(photoId)
 *   JetPhotoLibrary.list() -> [{id, dataUrl, name, size, addedAt}]
 *   JetPhotoLibrary.get(id)
 *   JetPhotoLibrary.bindDragDrop(zoneEl)
 *   JetPhotoLibrary.MAX -> 32
 */
(function () {
  'use strict';

  if (window.JetPhotoLibrary) return;

  var MAX_PHOTOS = 32;
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  var state = {
    library: [], // [{id, dataUrl, name, size, addedAt}]
  };

  var listeners = [];
  function emit() {
    listeners.forEach(function (fn) { try { fn(state.library); } catch (e) {} });
  }

  function on(fn) { listeners.push(fn); }

  function add(file) {
    return new Promise(function (resolve, reject) {
      console.log('[PHOTO-LIB] add called', file && file.name, file && file.type, file && file.size);
      if (!file) { console.error('[PHOTO-LIB] no file'); return reject(new Error('no file')); }
      if (state.library.length >= MAX_PHOTOS) {
        console.warn('[PHOTO-LIB] library full');
        var ja = window.JetAtolye;
        if (ja && ja.notify) ja.notify('Maksimum ' + MAX_PHOTOS + ' fotoğraf eklenebilir', 'warning');
        return reject(new Error('library full (' + MAX_PHOTOS + ')'));
      }
      if (ALLOWED_TYPES.indexOf(file.type) < 0) {
        console.warn('[PHOTO-LIB] invalid type', file.type);
        var ja2 = window.JetAtolye;
        if (ja2 && ja2.notify) ja2.notify("Bu dosya türü desteklenmiyor (JPG, PNG, WEBP). iPhone'daysan: Ayarlar → Kamera → Formatlar → En Uyumlu, ya da fotoğrafın ekran görüntüsünü alıp yükle.", 'warning', { duration: 10000 }); // C5/K9 (2026-09-30, METIN PAKETI)
        return reject(new Error('invalid type: ' + file.type));
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        console.log('[PHOTO-LIB] FileReader loaded, dataUrl length:', e.target.result.length);
        var photo = {
          id: 'ph-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7),
          dataUrl: e.target.result,
          name: file.name || 'photo',
          size: file.size,
          addedAt: Date.now(),
        };
        state.library.push(photo);
        console.log('[PHOTO-LIB] pushed to library, total:', state.library.length);
        emit();
        resolve(photo.id);
      };
      reader.onerror = function (err) {
        console.error('[PHOTO-LIB] read fail', err);
        reject(new Error('read fail'));
      };
      reader.readAsDataURL(file);
    });
  }

  function remove(photoId) {
    var i = state.library.findIndex(function (p) { return p.id === photoId; });
    if (i >= 0) {
      state.library.splice(i, 1);
      emit();
      return true;
    }
    return false;
  }

  function list() { return state.library.slice(); }
  function get(id) { return state.library.find(function (p) { return p.id === id; }) || null; }
  function clear() { state.library = []; emit(); }

  function bindDragDrop(zoneEl) {
    if (!zoneEl) return;
    zoneEl.addEventListener('dragover', function (e) {
      e.preventDefault();
      zoneEl.classList.add('is-dragover');
    });
    zoneEl.addEventListener('dragleave', function () {
      zoneEl.classList.remove('is-dragover');
    });
    zoneEl.addEventListener('drop', function (e) {
      e.preventDefault();
      zoneEl.classList.remove('is-dragover');
      var files = Array.from(e.dataTransfer.files || []).filter(function (f) {
        return f.type && f.type.startsWith('image/');
      });
      if (!files.length) return;
      var availableSlots = MAX_PHOTOS - state.library.length;
      if (files.length > availableSlots) {
        var ja = window.JetAtolye;
        if (ja && ja.notify) ja.notify('En fazla ' + MAX_PHOTOS + ' foto, ' + availableSlots + ' bos slot var', 'warning');
        files = files.slice(0, availableSlots);
      }
      Promise.all(files.map(function (f) { return add(f).catch(function () { return null; }); }))
        .then(function () {
          var ja = window.JetAtolye;
          if (ja && ja.notify) ja.notify(files.length + ' foto eklendi', 'success');
        });
    });
  }

  window.JetPhotoLibrary = {
    add: add,
    remove: remove,
    list: list,
    get: get,
    clear: clear,
    on: on,
    bindDragDrop: bindDragDrop,
    MAX: MAX_PHOTOS,
  };
})();
